import React from 'react'
import { Registry } from '@react-registry'
import { useSlate } from 'slate-react'

import { isActionDisable, performHistoryAction } from '../utils'
import { UndoIcon } from '../../Icon';

export const UndoButton = ({ format = 'undo', children }) => {
  const editor = useSlate()
  const handleMouseDown = (event) => {
    event.preventDefault()
    performHistoryAction(editor, format)
  }
  return (
    <React.Fragment>
      {children({ handleMouseDown, isDisable: { func: isActionDisable, params: { editor, format } } })}
    </React.Fragment>
  )
}

Registry.register(
  {
    iconName: <UndoIcon />,
    title: 'Undo',
    IngressComponent: UndoButton,
    isContentStackElement: true,
    inBasicToolbar: true,
    shortcut: {
      key: 'mod+z', callback: () => {
        // this is intentional
      }
    },
    toolbar: {
      inHoveringToolbar: false
    }
  },
  { id: 'undo', registry: 'editorButtons' }
)
